import "./background-image.css.js";
const t = {
  backgroundImage: "pf-v6-c-background-image",
  dirRtl: "pf-v6-m-dir-rtl"
};
export {
  t as default
};
